import { AnalyticEvents } from '@app/enums';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { InteractableColumn } from '@app/modules/table/interfaces/interactable-column.interface';
import { AnalyticService } from '@app/services';
import { EmployeeBenefit } from '@models/payroll/employee/benefit.model';

export class EffectiveAtColumn extends Column implements InteractableColumn {
    title = 'table.benefits.effectiveDate';
    property = 'effectiveDate';
    type: CellDisplay = CellDisplay.datepicker;

    constructor(
        private benefitId: number,
        private companyId: number,
        private analytics: AnalyticService
    ) {
        super();
    }

    getBindProperty(): string {
        return 'effectiveDate';
    }

    async onRowChange(row: EmployeeBenefit): Promise<void> {
        await row.param('benefit', this.benefitId).param('company', this.companyId).save();

        this.analytics.trackEvent(AnalyticEvents.PayrollBenefitsEmployeesChangeEffectiveDateInTableAutosaves);
    }
}
